'use client';
import React from 'react';
import { X } from 'lucide-react';
import type { FilterState } from './FilterSidebar';



interface ActiveFilterChipsProps {
  filters: FilterState;
  onChange: (filters: FilterState) => void;
}

export default function ActiveFilterChips({ filters, onChange }: ActiveFilterChipsProps) {
  const chips: { key: string; label: string; onRemove: () => void }[] = [];

  filters.curricula.forEach((c) =>
    chips.push({ key: `chip-curr-${c}`, label: c, onRemove: () => onChange({ ...filters, curricula: filters.curricula.filter((x) => x !== c) }) })
  );
  filters.khdaRatings.forEach((r) =>
    chips.push({ key: `chip-khda-${r}`, label: `KHDA: ${r}`, onRemove: () => onChange({ ...filters, khdaRatings: filters.khdaRatings.filter((x) => x !== r) }) })
  );
  if (filters.community)
    chips.push({ key: 'chip-community', label: `Near: ${filters.community}`, onRemove: () => onChange({ ...filters, community: '' }) });
  if (filters.busRequired)
    chips.push({ key: 'chip-bus', label: 'Bus Required', onRemove: () => onChange({ ...filters, busRequired: false }) });
  if (filters.startingFeeMin > 0 || filters.startingFeeMax < 999999)
    chips.push({ key: 'chip-startfee', label: `Starting Fee: AED ${filters.startingFeeMin.toLocaleString()}–${filters.startingFeeMax >= 999999 ? '+' : filters.startingFeeMax.toLocaleString()}`, onRemove: () => onChange({ ...filters, startingFeeMin: 0, startingFeeMax: 999999 }) });
  if (filters.finalYearFeeMin > 0 || filters.finalYearFeeMax < 999999)
    chips.push({ key: 'chip-finalfee', label: `Final Year Fee: AED ${filters.finalYearFeeMin.toLocaleString()}–${filters.finalYearFeeMax >= 999999 ? '+' : filters.finalYearFeeMax.toLocaleString()}`, onRemove: () => onChange({ ...filters, finalYearFeeMin: 0, finalYearFeeMax: 999999 }) });
  filters.yearGroups.forEach((yg) =>
    chips.push({ key: `chip-yg-${yg}`, label: yg, onRemove: () => onChange({ ...filters, yearGroups: filters.yearGroups.filter((x) => x !== yg) }) })
  );
  filters.genderPolicy.forEach((g) =>
    chips.push({ key: `chip-gender-${g}`, label: g, onRemove: () => onChange({ ...filters, genderPolicy: filters.genderPolicy.filter((x) => x !== g) }) })
  );
  filters.schoolType.forEach((t) =>
    chips.push({ key: `chip-type-${t}`, label: t, onRemove: () => onChange({ ...filters, schoolType: filters.schoolType.filter((x) => x !== t) }) })
  );
  filters.applicationStatus.forEach((s) =>
    chips.push({ key: `chip-status-${s}`, label: `Status: ${s}`, onRemove: () => onChange({ ...filters, applicationStatus: filters.applicationStatus.filter((x) => x !== s) }) })
  );
  if (filters.senSupport)
    chips.push({ key: 'chip-sen', label: 'SEN Support', onRemove: () => onChange({ ...filters, senSupport: false }) });
  if (filters.maxCommuteMinutes < 999)
    chips.push({ key: 'chip-commute', label: `Peak commute ≤${filters.maxCommuteMinutes}min`, onRemove: () => onChange({ ...filters, maxCommuteMinutes: 999 }) });
  if (filters.studentCountMax < 99999)
    chips.push({ key: 'chip-size', label: `Max ${filters.studentCountMax} students`, onRemove: () => onChange({ ...filters, studentCountMax: 99999 }) });

  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {chips.map((chip) => (
        <span
          key={chip.key}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/8 text-primary border border-primary/20 rounded-full text-xs font-medium"
        >
          {chip.label}
          <button onClick={chip.onRemove} className="hover:text-primary/70 transition-colors">
            <X size={12} />
          </button>
        </span>
      ))}
    </div>
  );
}